import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { getAlertGroupPermissions } from '../../../redux/actions/userStaffPreferencesActions';
import { FormattedMessage } from 'react-intl';
import HelpIcon from '../../shared/HelpIcon';
import InlineHelpText from '../../shared/InlineHelpText';
import { Link } from 'react-router-dom';
import {
  descriptionText,
  typeText,
} from '../../shared/SharedInternationalizations';
import Table from '../../shared/table/Table';
import AccessControl from '../../../AccessControl';
import permissions from '../../../permissionsList';
import { loadAlertGroups } from '../../../redux/actions/alertDeviceActions';

export function UnconnectedAlertGroupsPermissionDisplay(props) {
  const {
    alertDeviceTypes,
    alertDeviceDetails,
    user,
    alertGroupPermissions,
    currentLocation,
  } = props;
  useEffect(() => {
    props.dispatch(getAlertGroupPermissions());
    props.dispatch(loadAlertGroups());
  }, []); //eslint-disable-line
  let alertDeviceArr = [];
  let alertGroups = [];
  if (alertDeviceDetails) {
    alertDeviceArr = [...Object.values(alertDeviceDetails)];
    alertGroups = alertDeviceArr.filter(
      (device) =>
        device.alert_device_type === 13 || device.alert_device_type === 58
    );
  }

  const [
    showAlertGroupsDisplayHelpText,
    setShowAlertGroupsDisplayHelpText,
  ] = useState(false);
  function toggleShowAlertGroupsDisplayHelpText(value) {
    setShowAlertGroupsDisplayHelpText(value);
  }
  const alertGroupsHelpTextRef = useRef();
  const alertGroupsHelpText = (
    <FormattedMessage
      id="userCheckinPreferences.alertGroupsTitleHelpText"
      defaultMessage="The alert groups this user has permission to send messages to."
    />
  );

  function alertGroupDisplay() {
    const groups = Object.values(alertGroupPermissions).filter(
      (gr) => gr.user === user.id
    );
    if (groups.length > 0 && alertGroups.length > 0) {
      const groupsArray = groups.map((d) => {
        const device = alertDeviceDetails[d.alert_device];
        return {
          description: {
            sortBy: device.alert_description.toUpperCase(),
            display: device.alert_description,
          },
          type: {
            sortBy: alertDeviceTypes[
              device.alert_device_type
            ].description.toUpperCase(),
            display: alertDeviceTypes[device.alert_device_type].description,
          },
        };
      });

      const tableHeadings = [
        {
          isSortable: true,
          sortBy: 'description',
          display: descriptionText,
        },
        {
          isSortable: true,
          sortBy: 'type',
          display: typeText,
        },
      ];
      // generates the actual table
      const table = (
        <Table
          hasTableHead={true}
          hasSelector={false}
          tableHeadings={tableHeadings}
          sortParam="description"
          tableData={groupsArray}
          tableStyles="table__constrained table-layout__2-column"
          data-test="alert-groups-table"
        />
      );

      return table;
    } else {
      return (
        <FormattedMessage
          id="userDisplay.noAlertGroupsPermission"
          data-test="no-alert-groups-text"
          defaultMessage="This user does not have permission to send messages to any alert groups."
          description="The check-in instructions"
        />
      );
    }
  }

  return (
    <div
      className="content-display__column"
      data-test="call-for-checkin-container">
      <div className="content-display__item-pill-container">
        <div className="item-container__main-container">
          <div className="item-container__main-text text-large text-light">
            <FormattedMessage
              id="userDisplay.userAlertGroupsPermissionText"
              defaultMessage="Alert Groups this user has permission to send messages to"
              description="The check-in instructions"
            />

            <div
              className="text-medium text-bold"
              data-test="alert-groups-title">
              {alertGroupDisplay()}
            </div>
          </div>
        </div>
        <div className="item-container__info-container">
          <AccessControl
            data-test="access-control"
            userToEdit={user.id}
            feature={permissions.static.users.editUserAlertGroups}>
            <FormattedMessage
              id="userStaffProfile.editUserAlertGroups"
              defaultMessage="Edit Alert Groups"
              description="The check-in options"
              data-test="alert-groups-link-text">
              {(txt) =>
                user.is_active ? (
                  <Link
                    data-test="alert-groups-permissions-link"
                    to={`/users/${user.id}/edit/?mode=alertGroupEdit`}
                    state={{
                      modal: true,
                      previous: currentLocation,
                    }}
                    className="link-button button-secondary button-sm text-small">
                    {txt}
                  </Link>
                ) : (
                  ''
                )
              }
            </FormattedMessage>
          </AccessControl>
          <HelpIcon
            styles="margin-left-5"
            onClick={() => alertGroupsHelpTextRef.current.toggleHelpText()}
            toggled={showAlertGroupsDisplayHelpText}
          />
        </div>
      </div>
      <InlineHelpText
        ref={alertGroupsHelpTextRef}
        toggleFunction={toggleShowAlertGroupsDisplayHelpText}
        message={alertGroupsHelpText}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    alertDeviceTypes: state.devices.alertDeviceTypes,
    alertDeviceDetails: state.devices.alertDeviceDetails,
    alertGroupPermissions: state.users.alertGroupPermissions,
  };
};
export default connect(mapStateToProps)(
  UnconnectedAlertGroupsPermissionDisplay
);
